import { render, staticRenderFns } from "./obj_editor.vue?vue&type=template&id=1b95bc1e"
import script from "./obj_editor.vue?vue&type=script&lang=js"
export * from "./obj_editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports